import React, { useEffect } from "react";
import { Card, CardBody, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { DownloadIcon } from "../../../assets/images/svg/svg";
import { downloadDocumentFile, getAllOrderDocument } from "../../../service/order/orderService";
import { downloadFileFromURL } from "../../../utils/helper";
import NoDataFound from "../../../components/NoDataFound";
import { downloadDocument } from "../../../service/commonService";

const Documents = () => {
  const detailsData = useSelector(
    (state) => state.orders.selectedOrder.detailsData
  );
  const documents = useSelector(
    (state) => state.orders.selectedOrder.getAllOrderDocument
  );

  console.log(documents);

  useEffect(() => {
    getAllOrderDocument(detailsData.entityid);
  }, [detailsData.entityid]);

  return (
    <div className="document-row">
      {documents && documents.length > 0 ? (
        <Row>
          {documents.map((document, index) => (
            <Col xs="12" sm="6" lg="4" key={index}>
              <Card className="file-wrapper">
                <div className="file-content-wrapper">
                  <div className="filelabel">{document.name || "Document"}</div>
                  <div className="file-content">
                    <div className="filename">{document.filename}</div>
                    <div
                      className="info-icon-container"
                      onClick={() =>
                        downloadDocument(document.entityid, document.filename)
                      }
                    >
                      Download <DownloadIcon />
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default Documents;
